export const environment = {
  production: false,
  backendUrl: 'https://api-dev.splash.tech',
  hubFrontendUrl: 'http://localhost:4204',
  lottieAnimationEnabled: true,
};
